import React from "react";
import classes from "./MapModule.module.css";

//componenets


//assets
import locationIcon from "../../../../images/svgs/location.svg";
import phone from "../../../../images/svgs/phone.svg";
import fax from "../../../../images/svgs/fax.svg";
import email from "../../../../images/svgs/email.svg";

//This component renders the Card That contains the map frame and multiple locations with their info
const MapModule = (props) => {

  
  //activate the map button
  const selectMap = (event) => {
    var items = document.getElementsByClassName(classes.loc);
    for (var i = 0; i < items.length; i++) {
      items[i].className = classes.loc;
    }

    event.target.className = classes.loc + " " + classes.active;
  };

  return (
    <div className={classes.container}>
      <div className={classes.selector}>
        <h3
          onClick={(event) => {
            selectMap(event);
            props.selectSarafand();
          }}
          className={classes.loc + " "+(props.active === 1 ? classes.active:"")}
        >
          Sarafand
        </h3>
        <h3
          onClick={(event) => {
            selectMap(event);
            props.selectBeirut();
          }}
          className={classes.loc+ " "+(props.active === 2 ? classes.active:"")}
        >
          Beirut
        </h3>

        <h3
          onClick={(event) => {
            selectMap(event);
            props.selectBekaa();
          }}
          className={classes.loc+ " "+(props.active === 4 ? classes.active:"")}
        >
          Bekaa
        </h3>
        <h3
          onClick={(event) => {
            selectMap(event);
            props.selectTyre();
          }}
          className={classes.loc+ " "+(props.active === 3 ? classes.active:"")}
        >
          Tyre
        </h3>
      </div>
      <div className={classes.mapWrapper}>
        <iframe title="map" src={props.location}></iframe>
      </div>
      <div className={classes.info}>
        <h3>{props.info.title}</h3>
        <div className={classes.item}>
          <img src={locationIcon} alt={"location"} />
          <p>{props.info.location}</p>
        </div>
        <div className={classes.item}>
          <img src={phone} alt={"phone"} />
          <p>{props.info.phone}</p>
        </div>
        <div className={classes.item}>
          <img src={fax} alt={"fax"} />
          <p>{props.info.fax}</p>
        </div>
        <div className={classes.item}>
          <img src={email} alt={"email"} />
          <p>{props.info.email}</p>
        </div>
      </div>
    </div>
  );
};
export default MapModule;
